export enum ContentType {
    Channel = 'channel',
    Convo = 'convo',
    Message = 'message',
    Any = 'any',
    Menu = 'menu',
}
